import React from 'react'
import { Col, withCitrusTheme } from '@gousto-internal/citrus-react'

type OrderedColProps = Partial<React.ComponentProps<typeof Col>> & {
  order: number
}

const ThemedCol = withCitrusTheme(
  Col as React.ComponentType<OrderedColProps>,
  (theme, props: OrderedColProps) => {
    const breakpointToLarge = `@media (max-width: ${theme.tokens.breakpoints[2]})`
    return {
      [breakpointToLarge]: { order: props.order },
    }
  },
)

export function OrderedCol(props: OrderedColProps) {
  return <ThemedCol size={[12, null, null, 6]} {...props} />
}
